import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import UserService from '@/services/UserService';
import VueRecaptcha from '@/components/widget/VueRecaptcha';
import { validationMixin, useSpinValidate } from '@/plugins/vuelidateCompat';
import { required, email } from '@vuelidate/validators';
export default {
  components: {
    VueRecaptcha
  },
  data: () => {
    return {
      loading: false,
      username: null,
      email: null,
      resetMessageHTML: '',
      recoverMessageHTML: '',
      reset: false,
      recovered: false,
      resetCaptchaResponse: false,
      recoverCaptchaResponse: false
    };
  },
  mixins: [validationMixin],
  setup() {
    return useSpinValidate();
  },
  validations: {
    username: {
      required
    },
    email: {
      required,
      email
    }
  },
  methods: {
    resetPassword: function () {
      this.$v.username.$touch();
      if (this.$v.username.$invalid) {
        return;
      }
      this.loading = true;
      UserService.resetPassword(this.username, this.resetCaptchaResponse).then(response => {
        if (response && response.data && response.data.error.length === 0) {
          this.resetMessageHTML = '';
          response.data.success.forEach(e => {
            this.resetMessageHTML += e + '<br>';
          });
        } else {
          alert('Failed to reset password! ' + response.data.error[0]);
        }
        this.reset = true;
      }).catch(error => {
        alert('Failed to reset password! ' + error.data.error[0]);
        this.loading = false;
      }).finally(() => {
        this.loading = false;
      });
    },
    recoverUsername: function () {
      this.$v.email.$touch();
      if (this.$v.email.$invalid) {
        return;
      }
      this.loading = true;
      UserService.retrieveUsername(this.email, this.recoverCaptchaResponse).then(response => {
        if (response && response.data && response.data.error.length === 0) {
          this.recoverMessageHTML = '';
          response.data.success.forEach(e => {
            this.recoverMessageHTML += e + '<br>';
          });
          this.recovered = true;
        } else {
          alert('Failed to reset password! ' + response.data.error[0]);
        }
        this.loading = false;
      }).catch(error => {
        alert('Failed to reset password! ' + error.data.error[0]);
        this.loading = false;
      }).finally(() => {
        this.loading = false;
      });
    },
    handleResetSuccess(response) {
      this.resetCaptchaResponse = response;
    },
    handleResetError(response) {
      this.resetCaptchaResponse = false;
    },
    handleRecoverSuccess(response) {
      this.recoverCaptchaResponse = response;
    },
    handleRecoverError(response) {
      this.recoverCaptchaResponse = false;
    }
  }
};